import { reset, Tokens } from "marvin-auth-kit";
import { useMutation, UseMutationOptions } from "react-query";
import { APIError } from "src/types";

/**
 * Password reset request
 */
type PasswordResetMutationOptions = UseMutationOptions<boolean, APIError[] | Error, number, unknown>;
export function usePasswordResetMutation(options?: PasswordResetMutationOptions) {
  async function mutationFn(id: number) {
    const response = await reset.request(id);
    return response;
  }

  return useMutation((id: number) => mutationFn(id), options);
}

/**
 * Password reset confirm
 */
type PasswordResetConfirmMutationOptions = UseMutationOptions<Tokens, APIError[] | Error, string, unknown>;
export function usePasswordResetConfirmMutation(token: string, options?: PasswordResetConfirmMutationOptions) {
  async function mutationFn(token: string, password: string) {
    const response = await reset.confirm(token, password);
    return response;
  }

  return useMutation((password: string) => mutationFn(token, password), options);
}
